/**
 * Shared wrapper for form fields: label, required indicator, and error message.
 * Use with MonthField, MonthPicker, SelectField, and other form controls for consistent layout.
 * Pass `id` so the label is associated via htmlFor; the same id should be on the wrapped control.
 * When using id, the error element gets id `${id}-error`; pass aria-describedby={`${id}-error`} to your control when showing an error.
 */
export default function FieldWrapper({
  label,
  required,
  error,
  showError,
  children,
  className = "",
  /** Id of the form control; sets label htmlFor and error element id for aria-describedby */
  id,
}) {
  const errorId = id ? `${id}-error` : undefined;
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id ?? undefined} className="block text-sm font-medium mb-2">
          {label} {required ? <span className="text-palette-rose-badge">*</span> : null}
        </label>
      )}
      {children}
      {showError && error ? (
        <p id={errorId} className="mt-1 text-xs text-palette-rose-badge" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
